import {BuyNowButton, useProductOptions} from '@shopify/hydrogen';
import clsx from 'clsx';
// import {defaultButtonStyles} from '../../elements/Button';

type Props = {
  quantity?: number;
  showSoldOut?: boolean;
  isHidden?: boolean;
};

export default function SelectedVariantBuyNowButton({
  quantity = 1,
  showSoldOut = true,
  isHidden
}: Props) {
  const {selectedVariant} = useProductOptions();
  const availableForSale = selectedVariant?.availableForSale;

  if ((!showSoldOut && !availableForSale) || !selectedVariant?.id) {
    return null;
  }

  return (
    <BuyNowButton
      // className={defaultButtonStyles()}
      className={clsx(
        'w-fit text-shopPay border border-shopPay px-10 py-2 hover:bg-shopPay hover:text-white truncate',
        isHidden && 'hidden sm:block'
      )}
      disabled={!availableForSale}
      quantity={quantity}
      variantId={selectedVariant.id}
    >
      Buy now
    </BuyNowButton>
  );
}
